import { useEffect, useRef, useState } from "react";

export default function TenantCreationFiles({ files, onAdd, onRemove, isWorking, completed = false }) {
  const [previewError, setPreviewError] = useState("");
  const previews = useRef([]);

  useEffect(() => () => {
    previews.current.forEach((url) => URL.revokeObjectURL(url));
  }, []);

  const openFile = (file) => {
    setPreviewError("");
    const preview = window.open("about:blank", "_blank");
    if (!preview) {
      setPreviewError("Allow pop-ups to open this document");
      return;
    }
    preview.opener = null;
    const url = URL.createObjectURL(file);
    previews.current.push(url);
    preview.location.replace(url);
  };

  return (
    <fieldset className="admin-profile-section" disabled={isWorking}>
      <legend>Files</legend>
      {!completed && (
        <div className="admin-file-upload-panel">
          <label htmlFor="new-tenant-files">Add PDFs</label>
          <input
            id="new-tenant-files"
            type="file"
            accept="application/pdf,.pdf"
            multiple
            onChange={(event) => {
              onAdd(Array.from(event.target.files || []));
              event.target.value = "";
            }}
          />
          <span>Optional. PDFs up to 5 MB each. Files upload after the tenant is created.</span>
        </div>
      )}
      {previewError && <p className="admin-field-error" role="alert">{previewError}</p>}
      {!files.length ? <p className="admin-panel-empty">No files selected.</p> : (
        <ul className="admin-modal-file-list" aria-label="Creation files">
          {files.map((entry) => (
            <li key={entry.id}>
              <div className="admin-modal-file-details">
                <span className="admin-file-icon" aria-hidden="true">PDF</span>
                <div>
                  <strong>{entry.file.name}</strong>
                  <span>{entry.status === "uploaded" ? "Uploaded" : entry.status === "uploading" ? "Uploading..." : entry.status === "failed" ? "Upload failed" : "Ready to upload"}</span>
                  {entry.error && <p className="admin-field-error" role="alert">{entry.error}</p>}
                </div>
              </div>
              <div className="admin-row-actions">
                <button className="admin-button admin-button-secondary" type="button" onClick={() => openFile(entry.file)}>Open</button>
                {!completed && <button className="admin-button admin-button-danger" type="button" onClick={() => onRemove(entry.id)}>Remove</button>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </fieldset>
  );
}
